import * as tslib_1 from "tslib";
import { extractChildren } from '../util/children';
var View = /** @class */ (function () {
    function View(vnode) {
        this.__update(vnode);
    }
    Object.defineProperty(View.prototype, "children", {
        get: function () {
            return this.attrs.children;
        },
        enumerable: true,
        configurable: true
    });
    // Public API
    View.prototype.onInit = function () { };
    View.prototype.onCreate = function (dom) { };
    View.prototype.onUpdate = function (dom) { };
    View.prototype.onBeforeRemove = function (dom) { };
    View.prototype.onRemove = function () { };
    View.prototype.onBeforeUpdate = function (attrs) { };
    // Future (p)react connection
    View.prototype.setState = function (state, callback) {
        if (state === null)
            return;
        if (typeof state === 'function')
            Object.assign(this.state, state(this.state, this.attrs));
        else
            Object.assign(this.state, state);
        if (callback)
            callback();
    };
    // Mithril connection
    /** @internal */
    View.prototype.oninit = function (vnode) {
        this.__update(vnode);
        return this.onInit();
    };
    /** @internal */
    View.prototype.oncreate = function (vnode) {
        this.__update(vnode);
        return this.onCreate(vnode.dom);
    };
    /** @internal */
    View.prototype.onupdate = function (vnode) {
        this.__update(vnode);
        return this.onUpdate(vnode.dom);
    };
    /** @internal */
    View.prototype.onbeforeremove = function (vnode) {
        this.__update(vnode);
        return this.onBeforeRemove(vnode.dom);
    };
    /** @internal */
    View.prototype.onremove = function (vnode) {
        this.__update(vnode);
        return this.onRemove();
    };
    /** @internal */
    View.prototype.onbeforeupdate = function (vnode, old) {
        this.__update(vnode);
        return this.onBeforeUpdate(old.attrs);
    };
    View.prototype.view = function (vnode) {
        return this.render();
    };
    /** @internal */
    View.prototype.__update = function (vnode) {
        if ('dom' in vnode && vnode.dom)
            this.dom = vnode.dom;
        this.attrs = tslib_1.__assign({}, vnode.attrs, { children: extractChildren(vnode.children) });
    };
    return View;
}());
export { View };
